module.exports = "<div class=gmw-recap-table__header> <span class=heading-h5 ng-class=\"{\n      'h-green-text': $ctrl.highlight\n    }\" ng-bind=$ctrl.label> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/components/recap-table-header/recap-table-header.html
// module id = 239
// module chunks = 0